import React from 'react';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { CustomCellRendererProps } from 'ag-grid-react';

interface LinkColDefProps extends AdvancedColDef {
  label?: string;
}

const LinkRenderer: React.FC<CustomCellRendererProps> = params => {
  const label = params?.colDef?.cellRendererParams?.label ?? params.value;

  if (!params.value) {
    return null;
  }

  return (
    <a href={params.value} rel="noopener noreferrer" target="_blank">
      {label}
    </a>
  );
};

export const LinkColDef = ({ label, ...colDef }: LinkColDefProps): AdvancedColDef => ({
  cellRenderer: LinkRenderer,
  cellRendererParams: {
    label,
  },
  filter: false,
  ...colDef,
  ...absColDef(colDef),
});
